const Header = () => {
  return (
    <div
      className={`mb-12 rounded-xl min-h-48 bg-cover !bg-center max-w-2xl overflow-hidden`}
      style={{
        backgroundImage: `url(${"https://cdn.firouzeh.com/public/bank-pattern-onboarding.svg"})`,
      }}
    >
      <img
        src={"https://cdn.firouzeh.com/public/bank-home-card-blue.png"}
        className="m-auto max-w-[240px] relative  top-24"
        alt="Bank Card"
      />
    </div>
  );
};
export default Header;
